import { BookingDto } from '@timechef/core/api';

export interface BookingsByPeriod {
  period: BookingsPeriodEnum;
  items: Booking[];
}

export enum BookingsPeriodEnum {
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  NextBookings = 'NextBookings',
}

export enum DateTypeEnum {
  Unbooked = 'unbooked',
  Booked = 'booked',
  EventBooked = 'event-booked',
}

export interface PageInfo {
  hasMore: boolean;
  currentPageIndex: number;
}

export interface PageInfoWithData<T> extends PageInfo {
  data: T[];
}

export interface Booking extends BookingDto {
  calendarId?: any;
}
